<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <b style="line-height:1.5;">
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">
              <img :src="images.nt1">
            </span>
          </u>
        </b>
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:16.0pt;font-family:宋体;">FeNi &nbsp;</span>
        </b>
        <span
          style="font-family:Arial;font-size:12pt;line-height:1.5;"
        >FeNi: 1. Ni 10% 2.&nbsp;Ni 20% 3. Ni 50%</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt2">
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">FeSi</span>&nbsp; &nbsp; &nbsp;&nbsp;
        </b>
        <span style="font-family:Arial;font-size:12pt;line-height:1.5;">
          FeSi 75%, FeSi 72%,
          FeSi 65%
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt3">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:16.0pt;font-family:宋体;">FeMn &nbsp;</span>
        </b>
        <span style="font-family:宋体;font-size:12pt;text-indent:18pt;line-height:1.5;">HCFeMn，MCFeMn，LCFeMn</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt4">
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">FeMnSi</span>&nbsp; &nbsp; &nbsp;
        </b>
        <span style="font-family:Arial;font-size:12pt;line-height:1.5;">
          FeMn68Si18,
          FeMn65Si17, FeMn60Si14
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt5" width="200" height="115" alt style="line-height:1.5;">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:16.0pt;font-family:宋体;">FeMo</span>&nbsp; &nbsp; &nbsp;
        </b>
        <span style="font-family:Arial;font-size:12pt;line-height:1.5;">
          FeMo70,
          FeMo60, FeMo55
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt6" width="200" height="214" alt>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">FeCr</span>&nbsp; &nbsp;&nbsp;
        </b>
        <span style="font-family:宋体;font-size:12pt;line-height:1.5;">HCFeCr，MCFeCr，LCFeCr</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt7">
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">FeTi</span>&nbsp; &nbsp;&nbsp;
        </b>
        <span style="font-family:Arial;font-size:12pt;line-height:1.5;">FeTi40, FeTi30</span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.nt8">
      </p>
      <p>
        <b style="line-height:1.5;">
          <span style="font-size:16.0pt;font-family:宋体;">FeV &nbsp;</span>
        </b>
        <span style="font-family:Arial;font-size:12pt;text-indent:12pt;line-height:1.5;">
          FeV75, FeV50,
          FeV40
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        nt1: require("../../../assets/img/common/nt1.jpg"),
        nt2: require("../../../assets/img/common/nt2.jpg"),
        nt3: require("../../../assets/img/common/nt3.jpg"),
        nt4: require("../../../assets/img/common/nt4.jpg"),
        nt5: require("../../../assets/img/common/nt5.jpg"),
        nt6: require("../../../assets/img/common/nt6.jpg"),
        nt7: require("../../../assets/img/common/nt7.jpg"),
        nt8: require("../../../assets/img/common/nt8.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/nt.vue